@if (isMockMode()) {
  @if (isMockDialogExpanded()) {
    <div
      class="fixed right-4 top-4 z-[100] max-h-[80vh] w-full max-w-md overflow-auto rounded-lg border border-neutral-200 bg-white p-4 shadow-lg"
      role="dialog"
      aria-label="Mock order input"
    >
      <div class="mb-2 flex items-center justify-between gap-2">
        <h2 class="text-sm font-semibold">Mock order (test mode)</h2>
        <button
          type="button"
          (click)="isMockDialogExpanded.set(false)"
          class="rounded p-1 text-neutral-500 transition hover:bg-neutral-100 hover:text-neutral-700"
          [attr.aria-label]="'Minimize mock panel'"
        >
          <i class="icon icon-chevron-down rotate-180 text-sm"></i>
        </button>
      </div>
      <p class="mb-3 text-xs text-neutral-600">
        Paste DoodOrderModel JSON to display a mock order without calling the API.
      </p>
      <textarea
        [value]="mockOrderJson()"
        (input)="mockOrderJson.set($any($event.target).value); onMockOrderInputChange()"
        class="mb-3 min-h-[150px] w-full rounded border border-neutral-300 p-2 font-mono text-xs"
        placeholder='{"id": "...", "status": "READY", ...}'
        aria-describedby="mock-order-error"
      ></textarea>
      @if (mockOrderParseError()) {
        <p
          id="mock-order-error"
          class="mb-2 text-xs text-red-600"
          role="alert"
        >
          {{ mockOrderParseError() }}
        </p>
      }
    </div>
  } @else {
    <button
      type="button"
      (click)="isMockDialogExpanded.set(true)"
      class="fixed right-4 top-4 z-[100] rounded-lg border border-neutral-200 bg-white px-3 py-2 text-xs font-medium shadow transition hover:bg-neutral-50"
      [attr.aria-label]="'Expand mock panel'"
    >
      Mock
      <i class="icon icon-chevron-down -rotate-90 ml-1 inline-block text-xs"></i>
    </button>
  }
}

<div
  class="min-h-screen pb-page-bottom"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.backgroundImage]="backgroundImageCss"
  [style.backgroundSize]="backgroundImageCss ? 'cover' : null"
  [style.backgroundPosition]="backgroundImageCss ? 'center' : null"
  [style.backgroundRepeat]="backgroundImageCss ? 'no-repeat' : null"
>
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
